<flx-bottom-panel
  [size]="size()"
  (sizeChange)="size.set($event)"
>
  <ng-container flxExpandPanelHeader>
    @if (process?.instance && process?.definition) {
      <flx-process-instance-details-panel-header
        [state]="process.instance.state"
        [name]="process.definition.resourceName"
        [uuid]="process.instance.uuid"
      />
    }
  </ng-container>

  <ng-container class="panel-main-container">
    <flx-tab-bar
      [class.overflow-y-auto]="tabs[selectedTabIndex]?.id === tabNames.EXCEPTIONS.toLowerCase()"
      [selectedTabIndex]="selectedTabIndex"
      (selectedTabChange)="onTabChange($event)"
      class="flx-ds shadowless h-full px-6 pb-6"
    >
      @for (tab of tabs; track tab.id) {
        <flx-tab
          [label]="tab.header"
          [headerDataTestId]="`tab-${tab.id.toLowerCase()}`"
        >
          @if (tab.header === tabNames.EXCEPTIONS && process?.activeIncidents) {
            <ng-template flxTemplate="header">
              <div class="flex items-center">
                {{ tab.header }}
                <p-tag
                  [value]="process?.activeIncidents?.toString()"
                  class="flx-tag ml-2"
                  data-testid="active-incidents"
                  severity="danger"
                ></p-tag>
              </div>
            </ng-template>
          }
          <div
            class="h-full"
            flxTabContent
          >
            @if (selectedTabIndex === $index) {
              @switch (tab.header) {
                @case (tabNames.VARIABLES) {
                  <app-process-instance-variables
                    [processInstance]="process?.instance"
                    [processDefinition]="process?.definition"
                  />
                }
                @case (tabNames.TOKENS) {
                  <app-process-instance-tokens [process]="process" />
                }
                @case (tabNames.SUBPROCESSES) {
                  <app-process-instance-subprocesses
                    [processInstance]="process?.instance"
                    (goToProcess)="onGoToProcess($event)"
                  ></app-process-instance-subprocesses>
                }

                @case (tabNames.EXCEPTIONS) {
                  <app-instance-exceptions
                    [processInstanceUuid]="process?.instance?.uuid"
                  ></app-instance-exceptions>
                }
                @case (tabNames.AUDIT) {
                  <app-instance-audit-logs
                    [processInstanceUuid]="process?.instance?.uuid"
                    (subprocessNavigation)="onGoToProcess($event)"
                  ></app-instance-audit-logs>
                }
                @case (tabNames.WORKFLOWS) {
                  <flx-instance-workflows
                    [instanceUuid]="process?.instance?.uuid"
                    [workflowRunTriggerTypes]="['PROCESS_ENGINE']"
                  />
                }
                @case (tabNames.TRIGGER) {
                  <flx-instance-trigger [process]="process" />
                }
                @case (tabNames.NOTIFICATIONS) {
                  <flx-instance-notifications [processInstanceUuid]="process?.instance?.uuid" />
                }
                @case (tabNames.DOCUMENTS) {
                  <flx-instance-documents [processInstanceId]="process?.instance?.id" />
                }
              }
            }
          </div>
        </flx-tab>
      }
    </flx-tab-bar>
  </ng-container>
</flx-bottom-panel>
